/** Format date string to dd/mm/yyyy */
export function fmtDate(value: string | Date | null | undefined): string {
  if (!value) return '-'
  let d: Date
  if (typeof value === 'string') {
    // Acepta "YYYY-MM-DD", "YYYY-MM-DDTHH:MM:SS" y "YYYY-MM-DD HH:MM:SS"
    const s = value.includes('T')
      ? value
      : value.includes(' ')
        ? value.replace(' ', 'T')
        : value + 'T00:00:00'
    d = new Date(s)
  } else {
    d = value
  }
  if (isNaN(d.getTime())) return '-'
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

/** Format datetime string to dd/mm/yyyy HH:mm */
export function fmtDateTime(value: string | Date | null | undefined): string {
  if (!value) return '-'
  const d = typeof value === 'string' ? new Date(value) : value
  if (isNaN(d.getTime())) return '-'
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
    ' ' + d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })
}
